import type { SVGProps } from 'react';

const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10.91 16.003c-.26 0-.51-.1-.71-.29l-2.91-2.91a.996.996 0 1 1 1.41-1.41l2.21 2.21 5.38-5.3a.996.996 0 0 1 1.41.01c.39.39.38 1.03 0 1.41l-6.09 6c-.19.19-.45.29-.7.29z"
    />
  </svg>
);
export default SvgCheckmark;
